import React, { useState } from "react"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const responsive = {
    mobile: {
        breakpoint: { max: 10000, min: 0 },
        items: 1,
        slidesToSlide: 1, // optional, default to 1.
    },
}

const ButtonGroup = ({ 
    isAttached, 
    goToSlide,
    position,
    setPosition, 
    totalItems,
    ...rest 
}) => {
    let {
        carouselState: { currentSlide },
    } = rest

    const dotHandler = (index) => {
        goToSlide(index)
        setPosition(index)
    }

    return (
        <div className="absolute right-20 left-0 bottom-1 z-30 w-full">
            <div className="text-primary flex justify-center items-center gap-1">
                {[...Array(totalItems).keys()].map((dt, index) => 
                    isAttached ? (
                        <div className="m-1 cursor-pointer " onClick={() => dotHandler(index)} key={index}>
                            <img src={`/gallery_page/radio_${position === index ? "selected" : "default"}.svg`} className={`${position === index ? "w-4 h-4" : "w-2 h-2"}`} />
                        </div>
                    ) : (
                        <div className="m-1 cursor-pointer " onClick={() => goToSlide(index)} key={index}>
                            <img src={`/gallery_page/radio_${currentSlide === index ? "selected" : "default"}.svg`} className={`${currentSlide === index ? "w-4 h-4" : "w-2 h-2"}`} />
                        </div>
                    )
                )}
            </div>
        </div>
    )
}

const NFTItem = ({ item, index, itemClickHandler }) => {
    const [load, setLoad] = useState(false)
    const [error, setError] = useState(false)
    const [position, setPosition] = useState(item.thumbs.length - 1)
    const imageUrl = item.image
    const thumbUrl = item.thumb_image

    return (
        <div className="flex flex-col justify-center relative cursor-pointer" >
            <Carousel
                className={`pb-18 ${load ? "" : "hidden"}`}
                swipeable
                draggable
                responsive={responsive}
                infinite={false}
                arrows={null}
                autoPlay={false}
                customButtonGroup={
                <ButtonGroup 
                    isAttached={item.thumbs !== undefined && item.thumbs.length !== 0}
                    position={position}
                    setPosition={setPosition}
                    totalItems={item.thumbs.length}
                />}
                
            >
                {!load ? <img src="/gallery_page/loading.png" className=" animate-pulse rounded-t-3xl w-full" alt="nft item" /> : error &&
                    <img src="/gallery_page/default.png" className="bg-black rounded-t-3xl w-full" alt="nft item" onClick={() => itemClickHandler("/gallery_page/default.png")} />
                }
                <img src={thumbUrl !== undefined ? thumbUrl : "/gallery_page/default.png"} className={`rounded-t-3xl w-full ${load && !error ? "" : "hidden"}`} onLoad={() => { setLoad(true), ("loaded") }} onError={() => { setError(true), setLoad(true) }} alt="nft item" onClick={() => itemClickHandler(imageUrl, thumbUrl)} />
                {
                    item.thumbs !== undefined && item.thumbs.length !== 0 && item.thumbs.map((item, idx) => (
                        <img key={idx} src={`https://arweave.net/${item}`} alt="nft item" className="rounded-t-3xl w-full" onClick={() => itemClickHandler(imageUrl, thumbUrl)} />
                    ))
                }
            </Carousel>
            <div className="absolute bottom-0  xl:bottom-0 left-0 right-0 w-full">
                <h4 className="line-clamp-1 font-barlow-normal p-2 text-center text-lg bg-white">{item.name}</h4>
                <div className="bg-gradient-to-r h-8 flex from-white items-center justify-center rounded-b-full to-white via-gray-200">
                </div>
            </div>
        </div>
    )
}

export default NFTItem